module.exports = __webpack_public_path__ + "media/images/flag-319c8fad205ab651bc363d3e2ac84c60.svg";